// Единый формат чисел: 0 знаков после запятой + разделитель групп разрядов.
const numberFormatter = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 });

export const formatNumber = (value) => {
  const n = Number(String(value ?? "").replace(/\s/g, "").replace(",", "."));
  return numberFormatter.format(Number.isNaN(n) ? 0 : n);
};
